<script setup>

</script>

<template>
  <svg onclick="window.open('https://www.instagram.com/wyrld.app/')" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" class="icon">
    <path class="normal"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM43.4 19.4746C43.4 15.6862 40.32 12.6 36.5254 12.6H19.4746C15.6862 12.6 12.6 15.6862 12.6 19.4746V36.5254C12.6 40.32 15.6862 43.4 19.4746 43.4H36.5254C40.32 43.4 43.4 40.32 43.4 36.5254V19.4746ZM28 37.9792C22.4991 37.9792 18.0208 33.5009 18.0208 28C18.0208 22.4991 22.4991 18.027 28 18.027C33.5009 18.027 37.9792 22.4991 37.9792 28C37.9792 33.5009 33.5009 37.9792 28 37.9792ZM38.1886 19.838C37.0244 19.838 36.0758 18.8955 36.0758 17.7313C36.0758 16.567 37.0244 15.6184 38.1886 15.6184C39.3529 15.6184 40.3015 16.567 40.3015 17.7313C40.3015 18.8955 39.3529 19.838 38.1886 19.838ZM28 22.3513C24.8831 22.3513 22.3513 24.8831 22.3513 28C22.3513 31.117 24.8831 33.6549 28 33.6549C31.117 33.6549 33.6549 31.117 33.6549 28C33.6549 24.8831 31.117 22.3513 28 22.3513Z"
      fill="currentColor"
    />
    <path class="hover"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM43.4 19.4746C43.4 15.6862 40.32 12.6 36.5254 12.6H19.4746C15.6862 12.6 12.6 15.6862 12.6 19.4746V36.5254C12.6 40.32 15.6862 43.4 19.4746 43.4H36.5254C40.32 43.4 43.4 40.32 43.4 36.5254V19.4746ZM28 37.9792C22.4991 37.9792 18.0208 33.5009 18.0208 28C18.0208 22.4991 22.4991 18.027 28 18.027C33.5009 18.027 37.9792 22.4991 37.9792 28C37.9792 33.5009 33.5009 37.9792 28 37.9792ZM38.1886 19.838C37.0244 19.838 36.0758 18.8955 36.0758 17.7313C36.0758 16.567 37.0244 15.6184 38.1886 15.6184C39.3529 15.6184 40.3015 16.567 40.3015 17.7313C40.3015 18.8955 39.3529 19.838 38.1886 19.838ZM28 22.3513C24.8831 22.3513 22.3513 24.8831 22.3513 28C22.3513 31.117 24.8831 33.6549 28 33.6549C31.117 33.6549 33.6549 31.117 33.6549 28C33.6549 24.8831 31.117 22.3513 28 22.3513Z"
      fill="#2D2D3A"
    />
    <path class="hover"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56ZM43.4 19.4746C43.4 15.6862 40.32 12.6 36.5254 12.6H19.4746C15.6862 12.6 12.6 15.6862 12.6 19.4746V36.5254C12.6 40.32 15.6862 43.4 19.4746 43.4H36.5254C40.32 43.4 43.4 40.32 43.4 36.5254V19.4746ZM28 37.9792C22.4991 37.9792 18.0208 33.5009 18.0208 28C18.0208 22.4991 22.4991 18.027 28 18.027C33.5009 18.027 37.9792 22.4991 37.9792 28C37.9792 33.5009 33.5009 37.9792 28 37.9792ZM38.1886 19.838C37.0244 19.838 36.0758 18.8955 36.0758 17.7313C36.0758 16.567 37.0244 15.6184 38.1886 15.6184C39.3529 15.6184 40.3015 16.567 40.3015 17.7313C40.3015 18.8955 39.3529 19.838 38.1886 19.838ZM28 22.3513C24.8831 22.3513 22.3513 24.8831 22.3513 28C22.3513 31.117 24.8831 33.6549 28 33.6549C31.117 33.6549 33.6549 31.117 33.6549 28C33.6549 24.8831 31.117 22.3513 28 22.3513Z"
      fill="url(#paint0_linear_1423_1110)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1423_1110"
        x1="0"
        y1="0"
        x2="49"
        y2="49.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0243E7" />
        <stop offset="0.531567" stop-color="#FE1097" />
        <stop offset="1" stop-color="#FFC642" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.icon {
  --transition: opacity 0.3s;

  .normal {
    opacity: 1;
    transition: var(--transition);
  }
  .hover {
    opacity: 0;
    transition: var(--transition);
  }

  @media (hover: hover) {
    &:hover {
      .normal {
        opacity: 0;
      }
      .hover {
        opacity: 1;
      }
    }
  }

  @media (hover: none) {
    &:active {
      .normal {
        opacity: 0;
      }
      .hover {
        opacity: 1;
      }
    }
  }
}
</style>
